import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, IconButton } from '@mui/material';

const AssetDialogHeader = ({ onClose, expandRightSide, rightOpen, title, onTitleClick, showRightExpandIcon = true }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <DialogTitle onClick={onTitleClick} sx={{ cursor: 'pointer' }}>
        {' '}
        {title}
      </DialogTitle>
      <Box>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        {!rightOpen && showRightExpandIcon && (
          <IconButton onClick={expandRightSide}>
            <ChevronRightIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default AssetDialogHeader;
